import { render } from "./EditBoxForm.vue?vue&type=template&id=4a6a8c28"
import script from "./EditBoxForm.vue?vue&type=script&lang=js"
export * from "./EditBoxForm.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/volume-nbg1-3/html/musikalienverleih/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__